import {PC_BANG_MAIN_BANNERS_REQUEST, PC_BANG_MAIN_BANNERS_RESPONSE} from '../actions/mainBanners.actions';

const defaultMainBanners = [];

export default function mainBanners(state = defaultMainBanners, action) {
  switch (action.type) {
    case PC_BANG_MAIN_BANNERS_REQUEST: {
      return state;
    }
    case PC_BANG_MAIN_BANNERS_RESPONSE: {
      let nextState = action.mainBanners;
      return nextState;
    }
  }

  return state;
}
